import nextApi from '../next-api'
import { SearchItemPartials } from '@/lib/api/shopware/search/search.types'

const getSearchResult = (searchParam: string) => {
  return nextApi.get<SearchItemPartials[]>({ url: `/search/${searchParam}` })
}

export default getSearchResult
